import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ContentArea from '../../components/contentArea';
import ChallengeItem, { DailyCountChallengeItem } from '../../components/challengeItem';
import { challengeAPI } from '../../actions/imsServer';
import { API_PAGE_SIZE } from '../../constants';

export const RewardChallenge = () => {
    const theme = useTheme();
    const meInfo = JSON.parse(localStorage.getItem('meInfo') || '{}');

    // 실제 데이터 상태
    const [allChallenges, setAllChallenges] = useState([]);
    const [challengeProgressData, setChallengeProgressData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // 실제 데이터 가져오기 (100건씩 배치)
    const fetchChallengeData = async () => {
        try {
            setLoading(true);

            const fetchChallengeProgressBatched = async () => {
                let all = [];
                let offset = 0;
                let page;
                do {
                    const res = await challengeAPI.getChallengeProgress({
                        userId: meInfo.id,
                        state: 0,
                        expand: 'challenge',
                        offset
                    });
                    page = res?.data?.challengeProgresses || [];
                    all = all.concat(page);
                    offset += API_PAGE_SIZE;
                } while (page.length === API_PAGE_SIZE);
                return all;
            };

            const fetchChallengesBatched = async () => {
                let all = [];
                let offset = 0;
                let page;
                do {
                    const res = await challengeAPI.getChallenges({ state: 0, offset });
                    page = res?.data?.challenges || [];
                    all = all.concat(page);
                    offset += API_PAGE_SIZE;
                } while (page.length === API_PAGE_SIZE);
                return all;
            };

            const [challengeProgresses, challenges] = await Promise.all([
                fetchChallengeProgressBatched(),
                fetchChallengesBatched()
            ]);

            setAllChallenges(challenges);
            setChallengeProgressData(challengeProgresses);

        } catch (err) {
            console.error('챌린지 데이터 로딩 오류:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (meInfo.id) {
            fetchChallengeData();
        }
    }, [meInfo.id]);

    // 진행 상태를 챌린지 ID로 매핑
    const progressMap = {};
    if (challengeProgressData && Array.isArray(challengeProgressData)) {
        challengeProgressData.forEach(progress => {
            if (progress.challenge && progress.challenge.id) {
                progressMap[progress.challenge.id] = progress;
            }
        });
    }

    return (
        <ContentArea sx={{ paddingBottom: '100px' }}>
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                    <Typography>로딩 중...</Typography>
                </Box>
            ) : error ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                    <Typography color="error">오류: {error}</Typography>
                </Box>
            ) : allChallenges && allChallenges.length > 0 ? (
                [...allChallenges]
                    .sort((a, b) => (a.id || 0) - (b.id || 0))
                    .map((challenge, index) => {
                        const challengeProgress = progressMap[challenge.id];

                        // 진행 상태가 없으면 기본값으로 빈 카드 표시
                        const displayValue = challengeProgress?.value ?? 0;
                        const completedRewardPoints = challengeProgress?.rewardPoints ?? 0;
                        const completedCount = challengeProgress?.completedCount ?? 0;
                        const completedDates = challengeProgress?.completedDates ?? [];
                        const lastDate = challengeProgress?.lastDate ?? null;
                        return (
                            <Box
                                key={challenge.id || index}
                                sx={{
                                    width: '100%',
                                }}
                            >
                                {challenge.targetCount.length === 1 && challenge.targetCount[0] === 1 || challenge.targetCount.length > 1 ? (
                                    <ChallengeItem
                                        type={challenge.type}
                                        nameKey={challenge.name}
                                        value={displayValue}
                                        completedRewardPoints={completedRewardPoints}
                                        targetValue={challenge.targetValue}
                                        rewardPoint={challenge.rewardPoint}
                                        period={challenge.period}
                                        targetCount={challenge.targetCount}
                                        completedCount={completedCount}
                                        lastDate={lastDate}
                                    />
                                ) : (
                                    <DailyCountChallengeItem
                                        type={challenge.type}
                                        period={challenge.period}
                                        nameKey={challenge.name}
                                        value={displayValue}
                                        completedCount={completedCount}
                                        completedDates={completedDates}
                                        targetCount={challenge.targetCount}
                                        targetValue={challenge.targetValue}
                                        rewardPoint={challenge.rewardPoint}
                                        lastDate={lastDate}
                                    />
                                )}
                            </Box>
                        );
                    })
            ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                    <Typography>챌린지가 없습니다.</Typography>
                </Box>
            )}
        </ContentArea>
    );
};

export default RewardChallenge;